import { useCallback } from 'react';

import { useAuthStore } from './useAuthStore';
import { useVerifyOTP } from '@goodneighbor/api-client';

type UseVerifyOTPReturn = ReturnType<typeof useVerifyOTP>;
type VerifyOTPData = Parameters<UseVerifyOTPReturn['mutateAsync']>[0]['data'];

/**
 * @returns function to be verified with a code sent by SMS
 */
const useVerifyOtpWithPersistence = () => {
  const { mutateAsync, ...mutationMetadata } = useVerifyOTP();
  const setTokens = useAuthStore((state) => state.setTokens);

  const handleVerifyOtpWithPersistence = useCallback(
    async ({ code, ...rest }: VerifyOTPData) => {
      const { data } = await mutateAsync({
        data: { code, ...rest }
      });

      setTokens(data.tokens);

      return data;
    },
    [mutateAsync, setTokens]
  );

  return { handleVerifyOtpWithPersistence, ...mutationMetadata };
};

export { useVerifyOtpWithPersistence };
